import * as Packery from 'packery';

import { get, getAll } from '../../helpers/utilities';

export class LoadMore {
    private root: Element;
    private hiddenItems: Element[];
    private loadMore: HTMLButtonElement;
    private displayCount: number;
    private grid: Packery.Packery;

    constructor(root: Element, grid: Packery.Packery) {
        this.root         = root;
        this.grid         = grid;
        this.displayCount = parseInt(this.root.getAttribute('data-pagination') as string, 10);
        this.hiddenItems  = getAll('.js-application__item', this.root) as Element[];
        this.loadMore     = get('#js-application__load-more-btn') as HTMLButtonElement;

        if(this.loadMore) {
            this.loadMore.addEventListener('click', () => {
                this.displayNextItems();
            });
        }
    }


    /**
     * Displays the next X items on the page
     * 
     * @private
     * @returns void
     */
    private displayNextItems(): void {

        // Display the next X items
        const itemsToDisplay = this.hiddenItems.splice(0, this.displayCount);
        if(itemsToDisplay) {
            itemsToDisplay.forEach(item => {
                item.classList.remove('c-application__item--is-hidden');
            });
        }

        // Relayout packery
        this.grid.layout();

        // Hide the button if no items left
        if(this.hiddenItems.length === 0) {
            (this.loadMore.parentNode as Element).classList.add('u-hidden');
        }
    }
}
